<template><section><h3>图表介绍</h3>
<p>Gauge， 仪表盘。</p>
<h3>attrs</h3>
<table>
<thead>
<tr>
<th>属性名</th>
<th>类型</th>
<th>默认值</th>
<th>描述</th>
</tr>
</thead>
<tbody>
<tr>
<td>title</td>
<td>String | Function</td>
<td><code v-pre>d =&gt; d</code></td>
<td>标题</td>
</tr>
<tr>
<td>min</td>
<td>Number</td>
<td><code v-pre>0</code></td>
<td>最小值</td>
</tr>
<tr>
<td>max</td>
<td>Number</td>
<td><code v-pre>1</code></td>
<td>最大值</td>
</tr>
<tr>
<td>startAngle</td>
<td>Number</td>
<td>140</td>
<td>起始角度</td>
</tr>
<tr>
<td>endAngle</td>
<td>Number</td>
<td>400</td>
<td>结束角度</td>
</tr>
<tr>
<td>strokeBgcolor</td>
<td>String</td>
<td><code v-pre>#eee</code></td>
<td>背景色</td>
</tr>
<tr>
<td>lineWidth</td>
<td>Number</td>
<td><code v-pre>0</code></td>
<td>弧线宽度</td>
</tr>
<tr>
<td>lineCap</td>
<td>String</td>
<td><code v-pre>round</code></td>
<td>弧线线帽</td>
</tr>
<tr>
<td>tickStep</td>
<td>Number</td>
<td><code v-pre>0.1</code></td>
<td>tick 步进，生成 tick 的数量为 <code v-pre>(max - min) / tickStep</code></td>
</tr>
<tr>
<td>tickLength</td>
<td>Number</td>
<td><code v-pre>5</code></td>
<td>刻度长度，为负值时向外绘制</td>
</tr>
<tr>
<td>labelOffset</td>
<td>Number</td>
<td><code v-pre>5</code></td>
<td>刻度上文字与刻度线距离</td>
</tr>
<tr>
<td>tickFormatter</td>
<td>Function</td>
<td><code v-pre>d =&gt; d</code></td>
<td>刻度文本格式化</td>
</tr>
</tbody>
</table>
<h3>style</h3>
<p>组件中可以自定义 css 属性的元素如下表：</p>
<table>
<thead>
<tr>
<th>名称</th>
<th>基础类型</th>
<th>描述</th>
</tr>
</thead>
<tbody>
<tr>
<td>arc</td>
<td>线</td>
<td>弧线样式</td>
</tr>
<tr>
<td>pointer</td>
<td>面</td>
<td>仪表盘指针</td>
</tr>
<tr>
<td>title</td>
<td>文本</td>
<td>标题样式</td>
</tr>
<tr>
<td>tickLine</td>
<td>文本</td>
<td>刻度线样式</td>
</tr>
<tr>
<td>tickText</td>
<td>文本</td>
<td>刻度文字样式</td>
</tr>
</tbody>
</table>
</section></template><script>export default {components:{}}</script>